import { useSelector } from 'react-redux'
import { useHistory } from 'react-router';
import en from '../../../../lang/en-us';
import AsyncLoader from '../../../../lib/AsyncLoader'
import { SchemeSearchInput } from '../../../../lib/SearchInput';
import { favLogos } from '../../../../logo/logos'
import { RootStateType } from '../../../../redux-store/reducers'
import { AmcDetailSkelton } from '../../../../skeltons/NewPurchase'
import { rtaType } from '../../../common/FatcaCheck.types';
import { RTA_CODES } from '../../commercial/emandate/types';
import { ExplorePaths, Filter, FilterKeys } from '../../commercial/ExploreMFs/types'

const { dbCommercial } = en;

export const TransferOfUnits = () => {
  const { amcDetails } = useSelector(
    ({ newPurchase }: RootStateType) => ({ ...newPurchase.masterData }),
  );
  const { amcList } = useSelector(({ portfolio }: RootStateType) => ({ ...portfolio }));
  const history = useHistory();

  const onExploreSchemes = (filter: Filter & { rtaCode: RTA_CODES }) => {
    if (filter.rtaCode === RTA_CODES.KFIN) {
      window.open(process.env.REACT_APP_TRANSER_OF_UNITS_KFIN,
        '_system');
    } else {
      window.open(process.env.REACT_APP_TRANSER_OF_UNITS_CAMS,
        '_system');
    }
  };

  return (
    <div className="curved-bg commercial-trans">

      <div className="explore-mf-heading">
        <h2 className="heading">
          <a onClick={() => history.goBack()}>
            <img src="/images/left-arrow-black.svg" alt="icon" />
          </a>
          {dbCommercial.exploreMfs.transferOfUnits}
        </h2>
      </div>

      <div className="curved-bg-content explore-mf">
        <div className="explore-mf-top">
          <AsyncLoader
            skelton={<AmcDetailSkelton />}
            data={amcDetails.length ? true : null}
          >
            <div className="all-mfs-outer" style={{ borderBottom: 0 }}>
              <div className="all-mfs">
                {amcDetails.map((item) => {
                  let logoUrl = 'default';
                  const currentAmc: any =
                    amcList.find(
                      (amc: any) => amc.amc_name.toLowerCase() === item.amcFullName.toLowerCase(),
                    ) || undefined;
                  if (!!currentAmc) {
                    logoUrl = favLogos[currentAmc.amc_code];
                  }
                  return (
                    <a
                      key={item.amc}
                      onClick={() => {
                        const currentAmc: any =
                          amcList.find(
                            (amc: any) => amc.amc_name.toLowerCase() === item.amcFullName.toLowerCase(),
                          ) || undefined;
                        onExploreSchemes(
                          { name: item.amcFullName, value: item.amc, rtaCode: currentAmc.rta_code }
                        )
                      }}
                      className="all-mfs-info"
                    >
                      <img
                        style={{ width: '35px', height: '35px' }}
                        src={`/images/fav-logos/${logoUrl}.svg`}
                        alt="icon"
                      />
                      <p>{item.amcFullName}</p>
                    </a>
                  );
                })}
              </div>
            </div>
          </AsyncLoader>
        </div>
      </div>
    </div>
  )
}
